// Simple event bus for cross-component communication
type EventCallback = (data?: any) => void;

class EventBus {
    private listeners: { [key: string]: EventCallback[] } = {};

    on(event: string, callback: EventCallback) {
        if (!this.listeners[event]) {
            this.listeners[event] = [];
        }
        this.listeners[event].push(callback);

        // Return unsubscribe function
        return () => {
            this.off(event, callback);
        };
    }

    off(event: string, callback: EventCallback) {
        if (!this.listeners[event]) return;
        this.listeners[event] = this.listeners[event].filter(cb => cb !== callback);
    }

    emit(event: string, data?: any) {
        if (!this.listeners[event]) return;
        this.listeners[event].forEach(callback => callback(data));
    }
}

export const eventBus = new EventBus();

// Event constants
export const EVENTS = {
    EVENT_UPDATED: 'EVENT_UPDATED',
    PROFILE_UPDATED: 'PROFILE_UPDATED'
};
